import React from 'react';

import styled, { css } from 'styled-components';
import { FlexContainer, StyledBorderedPaper, VerticallyAlignedFlexContainer } from 'styles/common';

import theme from 'constants/theme';

import { Typography12, Typography14 } from 'uiToolkit/Typography';
import { Button } from 'uiToolkitV1/Button';

export const CompetencySettingsRow = ({ setShowSettingsScreen }) => (
  <BorderedPaper>
    <VerticallyAlignedFlexContainer>
      <FlexContainer style={{ flexDirection: 'column' }}>
        <Typography14>Competency Settings</Typography14>
        <Typography12 customColor={theme.palette.text.label}>
          Modify the competency settings by choosing the option that suits your organization.
        </Typography12>
      </FlexContainer>

      {/* <Button
        size="large"
        style={{ width: '10rem', marginLeft: 'auto' }}
        variant="outlined"
        color="primary"
        onClick={() => setShowSettingsScreen(true)}
      >
        <Typography13 customColor="primary">Settings</Typography13>
      </Button> */}
      <Button
        style={{ width: '10rem', marginLeft: 'auto' }}
        variant="outlined"
        onClick={() => setShowSettingsScreen(true)}
      >
        Settings
      </Button>
    </VerticallyAlignedFlexContainer>
  </BorderedPaper>
);

const BorderedPaper = styled(StyledBorderedPaper)`
  padding: 12px;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const StyledCompetencyHeaderCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 0.5rem 1rem;
  width: 280px;
  min-height: 60px;

  border: ${(props) => `1px solid ${props.theme.palette.borders.lighterGrey}`};
  border-left-width: 0px;

  background-color: white;

  ${(props) =>
    props.fixed &&
    css`
      width: 255px;
      position: sticky;
      left: 0px;
      z-index: 3;
      border-left-width: 1px;
    `};
`;
